import { useEffect, useState } from "react";
import api from "@/lib/api";

const isExternal = (s) => /^https?:\/\//i.test(s || "") || (s || "").startsWith("data:") || (s || "").startsWith("blob:");
export const isUploaded = (s) => !!s && !isExternal(s);

// Renders an image whose source may be an external URL or an authenticated
// object-storage path (fetched as a blob with the JWT token).
export default function AuthImage({ src, alt = "", className = "", ...rest }) {
  const [url, setUrl] = useState(isExternal(src) ? src : null);

  useEffect(() => {
    let revoke = null;
    let active = true;
    if (isExternal(src)) { setUrl(src); return; }
    setUrl(null);
    api.get(`/files/${src}`, { responseType: "blob" })
      .then((r) => { if (!active) return; revoke = URL.createObjectURL(r.data); setUrl(revoke); })
      .catch(() => { if (active) setUrl(null); });
    return () => { active = false; if (revoke) URL.revokeObjectURL(revoke); };
  }, [src]);

  if (!url) return <div className={`bg-muted animate-pulse ${className}`} aria-label={alt} />;
  return <img src={url} alt={alt} className={className} {...rest} />;
}
